import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Paths, Value } from '@utils/constants';
import { axios } from '@utils/lib';

export const getDbListAsync = createAsyncThunk(
  'api/getDbListAsync',
  async (request: IDbListParams, { rejectWithValue, dispatch }) => {
    const { id, query, hideLoading, tab } = request;
    const searchQuery: Record<string, string> = {
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'createdAt:desc',
    };
    if (query.name) searchQuery['filters[name]'] = query.name;

    const params = new URLSearchParams(searchQuery).toString();
    if (!hideLoading) dispatch(addLoading());

    try {
      const { data } = await axios.request<IListRes<IFaceDbData>>(
        Enums.HTTP_METHOD.GET,
        Paths.APPLICATION_LIST + '/' + id + Paths.DB + `/${tab}` + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const createPrivateDbAsync = createAsyncThunk(
  'api/createPrivateDbAsync',
  async (body: ICreatePrivateDb, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { applicationId, ...createData } = body;
    try {
      const { data } = await axios.request<IDataRes<IFaceDbData>>(
        Enums.HTTP_METHOD.POST,
        Paths.APPLICATION_LIST + '/' + applicationId + Paths.DB + `/private`,
        createData,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getDbDetailAsync = createAsyncThunk(
  'api/getDbDetailAsync',
  async (query: IDbDetailQuery, { rejectWithValue, dispatch }) => {
    const { appId, dbId, type } = query;
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IDbDetailRes>>(
        Enums.HTTP_METHOD.GET,
        Paths.APPLICATION_LIST +
          `/${appId}` +
          Paths.DB +
          `/${type}` +
          `/${dbId}`,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const updateDbAsync = createAsyncThunk(
  'api/updateDbAsync',
  async (data: IDbDetail, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id, appId, type, ...updateData } = data;
    try {
      const { data } = await axios.request<IDbDetailRes>(
        Enums.HTTP_METHOD.PUT,
        Paths.APPLICATION_LIST + `/${appId}` + Paths.DB + `/${type}` + `/${id}`,
        updateData,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const regenerateKeyAsync = createAsyncThunk(
  'api/regenerateKeyAsync',
  async (data: IGenerateKeyData, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { appId, dbId, type, ...body } = data;
    try {
      const { data } = await axios.request<IFaceDbDataRes>(
        Enums.HTTP_METHOD.POST,
        Paths.APPLICATION_LIST +
          `/${appId}` +
          Paths.DB +
          `/${type}` +
          `/${dbId}/roles`,
        body,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
